import { PayloadAction } from "@reduxjs/toolkit";
import { NotificationsState } from "../../models/NotificationsState";
import { ChangeNotificationsStatusPayload } from "../../payload/ChangeNotificationsStatus/ChangeNotificationsStatusPayload";

const changeNotificationsStatusFetch = (state: NotificationsState, action: PayloadAction<ChangeNotificationsStatusPayload>) => {
    state.isLoading = true;
}

export default changeNotificationsStatusFetch;